var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgComvivaLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "surface362971",
  xmlns: "http://www.w3.org/2000/svg",
  width: 117.856,
  height: 22.952,
  viewBox: "0 0 117.856 22.952"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "path1656",
  d: "M107.615,102.3l1.552-4.228a8.4,8.4,0,0,0-8.132,13.949h0l1.6,3.859.779-2.123,1.552-4.228a3.946,3.946,0,0,1,2.652-7.228",
  transform: "translate(-82.029 -96.546)",
  fill: "#faa61a"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  id: "path1658",
  d: "M124.958,98.053h0l-1.6-3.859-.779,2.122-1.552,4.228a3.946,3.946,0,0,1-2.652,7.228L116.824,112a8.4,8.4,0,0,0,8.132-13.949",
  transform: "translate(-93.813 -94.194)",
  fill: "#faa61a"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  id: "path1660",
  d: "M347.937,110.117a3.871,3.871,0,1,1,3.774-3.87,3.624,3.624,0,0,1-3.774,3.87m3.774-11.8v1.491a5.957,5.957,0,0,0-4.726-1.933,7.415,7.415,0,0,0-4.651,1.734l-2.861,7.808c.511,4.145,3.7,7.205,7.509,7.205a5.958,5.958,0,0,0,4.726-1.933v1.491h4.758V98.318Zm0,0",
  transform: "translate(-238.618 -96.585)",
  fill: "#ed1c24"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  id: "path1662",
  d: "M174.617,114.415l1.232-3.3v-6.579c0-4.022-2.416-6.661-6.114-6.661A5.3,5.3,0,0,0,165.069,100a4.787,4.787,0,0,0-4.215-2.124,4.935,4.935,0,0,0-4.312,1.933V98.076h-3.39L151.714,102v12.416H155.4l1.144-3.063v-6.01c0-1.9.9-3.025,2.51-3.025,1.544,0,2.317,1.027,2.317,2.638v9.46h3.745l1.082-2.9v-6.178c0-1.9.9-3.025,2.51-3.025,1.544,0,2.317,1.027,2.317,2.638v9.46Zm0,0",
  transform: "translate(-116.502 -96.586)",
  fill: "#ed1c24"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  id: "path1664",
  d: "M279.713,112.47V98.492h-3.637l-1.19,3.18v13.152h3.948Zm0,0",
  transform: "translate(-196.613 -96.989)",
  fill: "#ed1c24"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  id: "path1666",
  d: "M233.861,98.453l-3.768,11.97-.171-3.05L227,98.453h-5.342l6.035,16.339h5.468L239.2,98.453Zm0,0",
  transform: "translate(-161.992 -96.962)",
  fill: "#ed1c24"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  id: "path1668",
  d: "M59.345,109.931a3.681,3.681,0,0,1,0-7.359,3.284,3.284,0,0,1,3.077,1.776l4.155-2.411a8.172,8.172,0,0,0-7.168-4.06,8.582,8.582,0,0,0-6.236,2.648l-2.167,5.919a8.21,8.21,0,0,0,8.4,8.18,8.094,8.094,0,0,0,7.168-4.092l-4.155-2.379a3.252,3.252,0,0,1-3.077,1.776",
  transform: "translate(-51.006 -96.589)",
  fill: "#ed1c24"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  id: "path1670",
  d: "M305.658,98.451l-3.767,11.97-.171-3.05-2.937-8.92h-5.342l6.046,16.337h5.47L311,98.449Zm0,0",
  transform: "translate(-208.678 -96.96)",
  fill: "#ed1c24"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  id: "path1672",
  d: "M239.823,153.414h.732l-.269-.6c-.016-.039-.032-.082-.049-.132s-.033-.105-.05-.166c-.014.06-.03.111-.046.161s-.032.1-.049.137Zm1.18,1.031-.3-.676h-1.04l-.3.676h-.448l1.268-2.73,1.268,2.73Zm0,0",
  transform: "translate(-173.218 -131.601)",
  fill: "#fff"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  id: "path1674",
  d: "M250.391,152.375v2.263h-.427v-2.263h-.7v-.362h1.819v.362Zm0,0",
  transform: "translate(-179.95 -131.798)",
  fill: "#fff"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  id: "path1676",
  d: "M255.4,154.64v-2.626h1.465v.362h-1.038v.658h1.038v.375h-1.038v.846h1.038v.382Zm0,0",
  transform: "translate(-183.938 -131.798)",
  fill: "#fff"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  id: "path1678",
  d: "M262.888,152.536a1.317,1.317,0,0,0-.383-.232,1.188,1.188,0,0,0-.423-.077.936.936,0,0,0-.7.277,1.075,1.075,0,0,0-.007,1.416.873.873,0,0,0,.664.277,1.216,1.216,0,0,0,.444-.082,1.413,1.413,0,0,0,.4-.249v.483a1.274,1.274,0,0,1-.375.185,1.624,1.624,0,0,1-1-.037,1.313,1.313,0,0,1-.744-.734,1.484,1.484,0,0,1,0-1.087,1.344,1.344,0,0,1,.744-.739,1.478,1.478,0,0,1,.544-.1,1.44,1.44,0,0,1,.441.068,1.549,1.549,0,0,1,.407.2Zm0,0",
  transform: "translate(-187.365 -131.679)",
  fill: "#fff"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  id: "path1680",
  d: "M268.533,154.639v-2.626h.427v.966h1.291v-.966h.427v2.626h-.427v-1.275H268.96v1.275Zm0,0",
  transform: "translate(-192.479 -131.798)",
  fill: "#fff"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  id: "path1682",
  d: "M281.229,153.136c0-.02-.013-.077-.023-.169-.01-.077-.017-.14-.025-.19a1.312,1.312,0,0,1-.046.181,1.576,1.576,0,0,1-.074.181l-.687,1.4-.687-1.427c-.029-.06-.054-.115-.074-.17s-.039-.109-.055-.163a1.706,1.706,0,0,1-.013.173c-.008.06-.02.124-.035.189l-.282,1.293h-.393l.621-2.737.775,1.657c.012.027.03.07.055.131s.054.136.089.226a2.857,2.857,0,0,1,.121-.287c.015-.031.025-.055.032-.072l.757-1.655.635,2.737h-.4Zm0,0",
  transform: "translate(-199.179 -131.588)",
  fill: "#fff"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  id: "path1684",
  d: "M289.148,153.414h.732l-.269-.6c-.016-.039-.032-.082-.048-.132s-.033-.105-.05-.166c-.014.06-.03.111-.046.161s-.033.1-.049.137Zm1.18,1.031-.3-.676h-1.039l-.3.676h-.449l1.271-2.73,1.268,2.73Zm0,0",
  transform: "translate(-205.296 -131.601)",
  fill: "#fff"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  id: "path1686",
  d: "M296.211,154.639v-2.626h.427v.966h1.291v-.966h.427v2.626h-.427v-1.275h-1.291v1.275Zm0,0",
  transform: "translate(-210.482 -131.798)",
  fill: "#fff"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  id: "path1688",
  d: "M303.671,152.012h.427v2.626h-.427Zm0,0",
  transform: "translate(-215.332 -131.797)",
  fill: "#fff"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  id: "path1690",
  d: "M306.225,154.445v-2.73l1.668,1.6c.046.046.092.094.138.146s.1.109.147.174v-1.82h.394v2.725l-1.7-1.631c-.046-.044-.089-.091-.132-.139s-.083-.1-.121-.154v1.825Zm0,0",
  transform: "translate(-216.996 -131.601)",
  fill: "#fff"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  id: "path1692",
  d: "M314.67,154.252h.359a1.848,1.848,0,0,0,.444-.039.648.648,0,0,0,.257-.133.785.785,0,0,0,.223-.317,1.335,1.335,0,0,0,0-.88.785.785,0,0,0-.223-.317.664.664,0,0,0-.266-.133,2.168,2.168,0,0,0-.483-.039h-.309Zm-.427.385v-2.626h.576a3.768,3.768,0,0,1,.79.056,1.07,1.07,0,0,1,.4.189,1.1,1.1,0,0,1,.345.446,1.556,1.556,0,0,1,.118.623,1.536,1.536,0,0,1-.121.62,1.116,1.116,0,0,1-.345.446,1.078,1.078,0,0,1-.391.19,3.014,3.014,0,0,1-.685.056Zm0,0",
  transform: "translate(-222.207 -131.796)",
  fill: "#fff"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  id: "path1694",
  d: "M322.026,153.132h.077a.856.856,0,0,0,.45-.079.319.319,0,0,0,.111-.28.357.357,0,0,0-.121-.306.786.786,0,0,0-.442-.089h-.079Zm-.027.332v1.175h-.4v-2.626h.6a1.869,1.869,0,0,1,.406.034.647.647,0,0,1,.246.113.624.624,0,0,1,.189.246.808.808,0,0,1,.066.33.737.737,0,0,1-.153.494.672.672,0,0,1-.45.214l.906,1.194h-.483l-.873-1.175Zm0,0",
  transform: "translate(-226.992 -131.798)",
  fill: "#fff"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  id: "path1696",
  d: "M328.006,153.414h.732l-.269-.6c-.016-.039-.032-.082-.049-.132s-.033-.105-.05-.166c-.015.06-.03.111-.046.161s-.033.1-.049.137Zm1.18,1.031-.3-.676h-1.04l-.3.676H327.1l1.272-2.73,1.269,2.73Zm0,0",
  transform: "translate(-230.566 -131.601)",
  fill: "#fff"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  id: "path1698",
  d: "M340.135,152.536a1.319,1.319,0,0,0-.383-.232,1.184,1.184,0,0,0-.423-.077.935.935,0,0,0-.7.277,1.075,1.075,0,0,0-.007,1.416.873.873,0,0,0,.664.277,1.217,1.217,0,0,0,.444-.082,1.417,1.417,0,0,0,.4-.249v.483a1.268,1.268,0,0,1-.375.185,1.622,1.622,0,0,1-1-.037,1.313,1.313,0,0,1-.744-.735,1.484,1.484,0,0,1,0-1.087,1.341,1.341,0,0,1,.743-.739,1.48,1.48,0,0,1,.547-.1,1.435,1.435,0,0,1,.441.068,1.557,1.557,0,0,1,.407.2Zm0,0",
  transform: "translate(-237.603 -131.679)",
  fill: "#fff"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  id: "path1700",
  d: "M347.39,153.22a1,1,0,0,0-.073-.379.971.971,0,0,0-.209-.319.914.914,0,0,0-.307-.213.96.96,0,0,0-1.256.53,1,1,0,0,0-.072.38.985.985,0,0,0,.072.376.971.971,0,0,0,.208.318.932.932,0,0,0,.679.287.921.921,0,0,0,.362-.074.965.965,0,0,0,.311-.213.986.986,0,0,0,.282-.694m.444,0a1.341,1.341,0,0,1-.411.974,1.416,1.416,0,0,1-1.988,0,1.347,1.347,0,0,1-.3-.443,1.364,1.364,0,0,1,.3-1.51,1.392,1.392,0,0,1,.456-.3,1.47,1.47,0,0,1,1.077,0,1.39,1.39,0,0,1,.76.747,1.359,1.359,0,0,1,.105.529",
  transform: "translate(-242.23 -131.687)",
  fill: "#fff"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  id: "path1702",
  d: "M355.71,153.136c0-.02-.013-.077-.024-.169-.01-.077-.017-.14-.025-.19a1.291,1.291,0,0,1-.046.181,1.559,1.559,0,0,1-.074.181l-.687,1.4-.687-1.427c-.029-.06-.053-.115-.074-.17s-.039-.109-.055-.163a1.637,1.637,0,0,1-.013.173c-.008.06-.02.124-.035.189l-.282,1.293h-.393l.62-2.737.775,1.657c.012.027.03.07.055.131s.054.136.089.226a3.1,3.1,0,0,1,.121-.287c.015-.031.025-.055.032-.072l.757-1.655.635,2.737H356Zm0,0",
  transform: "translate(-247.62 -131.588)",
  fill: "#fff"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  id: "path1704",
  d: "M363.528,153.11h.11a.961.961,0,0,0,.473-.077.3.3,0,0,0,.121-.272.331.331,0,0,0-.126-.3.887.887,0,0,0-.466-.086h-.11Zm-.027.35v1.178h-.4v-2.626h.646a2.065,2.065,0,0,1,.423.031.661.661,0,0,1,.236.1.612.612,0,0,1,.194.246.819.819,0,0,1,.07.342.839.839,0,0,1-.07.344.6.6,0,0,1-.194.247.643.643,0,0,1-.236.1,2.077,2.077,0,0,1-.423.031Zm0,0",
  transform: "translate(-253.984 -131.797)",
  fill: "#fff"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  id: "path1706",
  d: "M367.586,153.414h.732l-.269-.6c-.016-.039-.032-.082-.049-.132s-.034-.105-.051-.166c-.014.06-.03.111-.045.161s-.033.1-.049.137Zm1.18,1.031-.3-.676h-1.039l-.3.676h-.449l1.271-2.73,1.268,2.73Zm0,0",
  transform: "translate(-256.307 -131.601)",
  fill: "#fff"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  id: "path1708",
  d: "M374.441,154.445v-2.73l1.668,1.6c.046.046.092.094.138.146s.1.109.147.174v-1.82h.394v2.725l-1.7-1.631c-.046-.044-.089-.091-.132-.139s-.083-.1-.121-.154v1.825Zm0,0",
  transform: "translate(-261.356 -131.601)",
  fill: "#fff"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  id: "path1710",
  d: "M382.638,154.639v-1.2l-.884-1.424h.449l.551.892c.013.023.029.052.049.089s.039.077.06.121c.017-.042.034-.082.053-.121a.684.684,0,0,1,.06-.1l.565-.88h.427l-.906,1.424v1.2Zm0,0",
  transform: "translate(-266.112 -131.798)",
  fill: "#fff"
})));
export { SvgComvivaLogo as ReactComponent };
export default __webpack_public_path__ + "static/media/comviva-logo.45738fc35a5d95d312d062c1f0ff94cf.svg";